<template>
    <div class="bd">
       
        <div class="my-custom-table">
            <a-page-header title="菜单列表"/>
            <div class="search-bar">
                <div class="tabInput">
                    <a>菜单名称：</a>
                    <a-input v-model:value="menuName" placeholder="请输入菜单名称进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <!-- 添加数据 -->
                        <addComponent ref="childOpen" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <!-- 渲染颜色 -->
                    <template v-if="column.key === 'menuName' && !editableData[record.id]">
                        <a>
                            {{ record.menuName }}
                        </a>
                    </template>
                    <template v-if="column.key === 'menuCode' && !editableData[record.id]">
                        <span>
                            <a-tag color="green">
                                {{ record.menuCode }}
                            </a-tag>
                        </span>
                    </template>
                    <!-- 渲染修改项 -->
                    <template v-if="['menuName', 'menuCode', 'url', 'icon', 'orderIndex'].includes(column.dataIndex)">
                        <div>
                            <a-input v-if="editableData[record.id]"
                                v-model:value="editableData[record.id][column.dataIndex]" style="margin: -5px 0" />
                            <template v-else>
                                <span v-if="column.key != 'menuName' && column.key != 'menuCode'">
                                    {{ text }}
                                </span>
                            </template>
                        </div>
                    </template>

                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <span v-if="editableData[record.id]">
                                <a-popconfirm title="确认保存？" ok-text="是" cancel-text="否" @confirm="save(record.id)">
                                    <a-tag @click="cancel(record.id)" color="#108ee9">
                                        <a style="margin: 15px;">取消</a>
                                    </a-tag>
                                    <a-tag color="#108ee9">
                                        <a style="margin: 15px;">保存</a>
                                    </a-tag>
                                </a-popconfirm>
                            </span>
                            <span v-else>
                                <a @click="edit(record.id)">修改</a>
                                <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                    <a style="margin: 15px;">删除</a>
                                </a-popconfirm>
                            </span>
                        </div>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import { menuPage, updateMenus, removeMenu } from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, reactive, h } from 'vue';
import addComponent from './modal/addComponent.vue'; // 导入组件

export default {
    name: 'SetPage',
    components: {
        addComponent
    },
    setup() {
        const data = ref([]); // 初始化为空数组
        const menuName = ref('');//查询条件
        const childOpen = ref(null);//子页面实例
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '菜单名称', dataIndex: 'menuName', key: 'menuName', width: '10%', },
            { title: '菜单代码', dataIndex: 'menuCode', key: 'menuCode', width: '10%', },
            { title: '菜单链接', dataIndex: 'url', key: 'url', width: '10%', },
            { title: '菜单图标', dataIndex: 'icon', key: 'icon', width: '10%', },
            { title: '父级菜单', dataIndex: 'parentName', key: 'parentName', width: '10%', },
            { title: '排序', dataIndex: 'orderIndex', key: 'orderIndex', width: '10%', },
            { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '10%', },
            { title: '操作', dataIndex: 'operation', width: '10%', },
        ];
        //查询数据
        const list = async () => {
            const response = await menuPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                menuName: menuName.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    menuName: item.menuName,
                    menuCode: item.menuCode,
                    url: item.url,
                    icon: item.icon,
                    parentName: item.parentName,
                    orderIndex: item.orderIndex,
                    createdAt: item.createdAt,
                }));
            }
        };
        // 组件初始化时调用一次
        list();
        //修改菜单
        const updateMenu = async (data) => {
            const response = await updateMenus(data);
            if (response.code === 200) {
                message.success('修改成功');
                return true;
            } else {
                message.error('修改错误：' + response.msg);
                return false;
            }
        };
        //删除菜单
        const deleteMenus = async (data) => {
            const response = await removeMenu(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };
        //修改的数据
        const editableData = reactive({});
        //修改按钮
        const edit = id => {
            editableData[id] = cloneDeep(data.value.filter(item => id === item.id)[0]);
        };
        //修改保存
        const save = id => {
            if (updateMenu(editableData[id])) {
                Object.assign(data.value.filter(item => id === item.id)[0], editableData[id]);
                delete editableData[id];
            }
        };
        //关闭修改
        const cancel = id => {
            delete editableData[id];
        };
        //删除
        const remove = id => {
            if (deleteMenus(id)) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };
        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            menuName.value = ''; // 重置搜索关键词
            list(); // 重置后重新获取数据
        }
        //添加
        const toAdd = () => {
            childOpen.value.open = true;
        }
        return {
            columns,
            pagination,
            data,
            editableData,
            deleteMenus,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            onSearch,
            onReset,
            addComponent,
            toAdd,
            childOpen,
            ref,
            h,
            remove,
            menuName,
            updateMenu,
            cancel,
            save,
            edit,
            list,
        };
    },
};
</script>
<style></style>